import { EContractStatus, useUserGetQuery } from '~/graphql/types'
import { Container } from './styles'
import { formatDate, translateContractStatus, formatHour } from '~/utils'
import { Tooltip } from '@mui/material'
import { useContract } from '~/contexts'

type ContractStatusProps = {
  status?: EContractStatus | null
}
export const ContractStatus: React.FC<ContractStatusProps> = ({ status }) => {
  const { contract } = useContract()

  const { data: userData } = useUserGetQuery({
    variables: {
      id: contract?.cancellationRequestedBy || ''
    },
    skip: !contract?.cancellationRequestedBy
  })

  const userName = userData?.userGet?.name || contract?.cancellationRequestedBy || 'Usuário não encontrado'

  const shouldShowTooltip = status && [EContractStatus.cancellationRequested, EContractStatus.inDeactivation, EContractStatus.deactivated].includes(status)

  return (
    <Container status={status || EContractStatus.reserved}>
      {shouldShowTooltip ? (
        <Tooltip
          placement='bottom-end'
          title={`${userName} alterou o status do contrato para: Cancel. Solicitado em ${formatDate(contract?.cancellationRequestedAt)} às ${formatHour(contract?.cancellationRequestedAt)}`}
          componentsProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -8]
                  }
                }
              ]
            }
          }}
        >
          <span>{translateContractStatus(status || EContractStatus.reserved)}</span>
        </Tooltip>
      ) :
        <span>{translateContractStatus(status || EContractStatus.reserved)}</span>
      }
    </Container>
  )
}
